import { InputNumber } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'

/**
 * 文件上传大小限制
 *
 * @param param - 参数
 * @param param.fileSizeLimit - 最小数量
 * @param param.isUserField - 是否为用户字段
 * @param param.onChange - 数量发生变化时的回调
 * @returns React.ReactNode
 */
export const FileSizeSetting: React.FC<{
  fileSizeLimit?: number | null
  isUserField?: boolean
  onChange: (v: number | null) => void
}> = ({ fileSizeLimit, isUserField, onChange }) => {
  return (
    <FileSizeSettingWrapper>
      <div>单个不超过</div>
      <InputNumber
        disabled={!!isUserField}
        addonAfter="M"
        value={fileSizeLimit}
        onChange={(v) => onChange(v)}
      />
    </FileSizeSettingWrapper>
  )
}

const FileSizeSettingWrapper = styled.div`
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    width: 78px;
    height: 28px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.text._2};
  }
  &&& {
    .ant-input-number-group-wrapper {
      width: 186px;
      .ant-input-number {
        height: 32px;
        border: 1px solid transparent;
        background-color: ${(props) => props.theme.background._3};
      }
      .ant-input-number-group-addon {
        border: transparent;
        border-left: 1px solid ${(props) => props.theme.border.greyNormal};
        background-color: ${(props) => props.theme.background._3};
      }
      .ant-input-number-handler-wrap {
        display: none;
      }
    }
  }
`
